export const boxShadowMixin = (color: string) => ({
  boxShadow: `inset 0px 0px 2px ${color}`,
});
